export default __webpack_public_path__ + "static/media/logo-sauce-white.c4fe3045.svg";